export const itemHeaderLightsOn = "Pyc";
export default {itemHeaderLightsOn};